// formik components
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Formik, Form } from "formik";
import { useLocation, useNavigate, useParams } from "react-router-dom";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// components
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

// example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// BalanceSheetDetail layout schemas for form and form feilds
import form from "./schemas/form";
import BalanceSheetInfo from "./info";
import validation from "./schemas/validations";
import Loading from "components/Common/Loading";
import initialValues from "./schemas/initialValues";
import { ImageService } from "services/imageService";
import { BalanceSheetService } from "services/balanceSheetService";

function BalanceSheetDetail() {
  const { formId, formField } = form;
  const { id } = useParams();
  const location = useLocation();
  const containEdit = location.pathname?.includes("/edit");
  const navigation = useNavigate();
  const [data, setData] = useState();

  useEffect(() => {
    if (!id) return;
    (async () => {
      try {
        const { data } = await BalanceSheetService.getById(id);
        setData(data);
      } catch (error) {
        toast.error(error?.response?.data?.message || "Lấy dữ liệu thất bại");
      }
    })();
  }, [id]);

  const handleBack = () => navigation(-1);

  const submitForm = async (values, actions) => {
    try {
      const [url] = await ImageService.uploadMany([values.logo]);
      if (!url) return;
      const payload = {
        company: "12312",
        reportingUnit: "Soin media",
        address: "Tp HCM",
        time: 1698288555245,
        type: "Mẫu số B 01 – DN",
        unit: "USD",
        fields: [],
        total: 2000000,
      };

      if (id) {
        await BalanceSheetService.update(id, payload);
        await ImageService.deleteImage(data.logo);
      } else {
        await BalanceSheetService.create(payload);
      }
      actions.setSubmitting(false);
      !id && actions.resetForm();
      toast.success(`${id ? "Cập nhật" : "Tạo"} thành công`);
    } catch (error) {
      toast.error(error?.response?.data?.message || `${id ? "Cập nhật" : "Tạo"} thất bại`);
      actions.setSubmitting(false);
      console.error({ error });
    }
  };

  const handleSubmit = (values, actions) => {
    submitForm(values, actions);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3} mb={20}>
        <Grid container justifyContent="center" sx={{ height: "100%" }}>
          <Grid item xs={12} lg={12}>
            <Formik
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Card sx={{ height: "100%" }}>
                    <SoftBox p={2}>
                      <SoftBox>
                        <BalanceSheetInfo
                          formData={{
                            values,
                            touched,
                            formField,
                            errors,
                            setFieldValue,
                          }}
                          data={data}
                        />
                        <SoftBox mt={10} width="100%" display="flex" justifyContent="space-between">
                          <SoftButton variant="gradient" color="light" onClick={handleBack}>
                            Trở về
                          </SoftButton>
                          {(!id || (id && containEdit)) && (
                            <SoftBox display="flex" gap={3}>
                              <SoftButton
                                disabled={isSubmitting}
                                type="submit"
                                variant="gradient"
                                color="dark"
                              >
                                {isSubmitting ? (
                                  <Loading width={25} height={25} />
                                ) : id && containEdit ? (
                                  "Cập nhật"
                                ) : (
                                  "Tạo"
                                )}
                              </SoftButton>
                            </SoftBox>
                          )}
                        </SoftBox>
                      </SoftBox>
                    </SoftBox>
                  </Card>
                </Form>
              )}
            </Formik>
          </Grid>
        </Grid>
      </SoftBox>
    </DashboardLayout>
  );
}

export default BalanceSheetDetail;
